import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { IconDirective } from '@coreui/icons-angular';
import { cilChatBubble, cilEnvelopeClosed, cilCheckCircle } from '@coreui/icons';
import { HomeService } from '../../../service/home.service';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSwitcherComponent } from '../../../shared/language-switcher/language-switcher.component';
import { LocaleService } from '../../../service/locale.service';

@Component({
  selector: 'app-home-footer',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    IconDirective,
    TranslateModule,
    LanguageSwitcherComponent,
  ],
  templateUrl: './home-footer.component.html',
  styleUrl: './home-footer.component.scss'
})
export class HomeFooterComponent {
  icons = {
    cilChatBubble,
    cilEnvelopeClosed,
    cilCheckCircle
  };

  email = '';
  submitting = signal(false);
  subscribed = signal(false);
  errorMsg = signal('');

  constructor(
    private homeService: HomeService,
    private locale: LocaleService,
  ) {}

  subscribe(): void {
    this.errorMsg.set('');
    const email = (this.email || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.errorMsg.set(this.locale.instant('marketing.footer.invalidEmail'));
      return;
    }
    this.submitting.set(true);
    this.homeService.subscribe_newsletter(email).subscribe({
      next: (res: any) => {
        this.submitting.set(false);
        if (res?.ok) {
          this.subscribed.set(true);
          this.email = '';
        } else {
          this.errorMsg.set(res?.msg || this.locale.instant('marketing.footer.subscribeFailed'));
        }
      },
      error: (err) => {
        this.submitting.set(false);
        this.errorMsg.set(err?.error?.msg || this.locale.instant('marketing.footer.subscribeFailed'));
      },
    });
  }
}
